'use client'

import earthPic from '@/assets/images/earth.png';
import { Link } from "react-router-dom";
import React from "react";
export default function ContactUs() {

  const [message, setMessage] = React.useState('');

  return (
      <div>
        {/* investment区域 */}
        <section
          className="relative top-0 bg-white"
          style={{height: '932px', overflow: 'hidden'}}
        >
          {/* 背景图片 - 右侧50%宽度 */}
          <div className="absolute top-0 right-0 w-3/5 h-full z-0" style={{transform: " scale(1.5) translateX(201px) translateY(-105px) rotateX(180deg) rotate(-50deg)"}}>
            <img
              src={earthPic}
              alt="Investment Background"
              className="object-cover"
            />
            <div className="absolute w-full h-full top-0 left-0  bg-gradient-to-tl from-white/0 to-white/100"></div>
          </div>

          <div className="w-[775px] relative top-[184px] inline-flex flex-col justify-start items-start gap-5">
            <div className="self-stretch justify-start text-[#414141] text-neutral-900/80 text-7xl font-medium font-['Figtree'] leading-[83.60px] -tracking-wide">Contact Us</div>
            <div className="justify-start">
              <span className="text-[#676767] text-xs font-normal font-['Figtree'] leading-none">Send us a message by filling out the form. We’ll be in touch shortly.</span>
            </div>
            <div className="w-96 p-5 box-content bg-stone-50 rounded-xl outline outline-1 outline-offset-[-1px] inline-flex flex-col justify-center items-center gap-6">
              <div className="self-stretch flex flex-col justify-center items-center gap-2.5">
                <div className="self-stretch inline-flex justify-start items-start gap-2.5">
                  <div style={{border: '1px solid rgba(60, 59, 59, 0.2)'}} className="flex-1 h-10 px-4 py-1 bg-white rounded-full focus-within:border-opacity-20 flex justify-start items-center">
                    <div className="w-full h-full flex justify-start items-start overflow-hidden">
                      <input className="w-full h-full justify-center bg-white text-[#636262] text-xs font-normal font-['Figtree'] leading-relaxed outline-none focus:outline-none focus:ring-0 placeholder-[#636262]" placeholder="First Name"/>
                    </div>
                  </div>
                  <div style={{border: '1px solid rgba(60, 59, 59, 0.2)'}} className="flex-1 h-10 px-4 py-1 bg-white rounded-full focus-within:border-opacity-20 flex justify-start items-center">
                    <div className="w-full h-full flex justify-start items-start overflow-hidden">
                      <input className="w-full h-full justify-center bg-white text-[#636262] text-xs font-normal font-['Figtree'] leading-relaxed outline-none focus:outline-none focus:ring-0 placeholder-[#636262]" placeholder="Last Name"/>
                    </div>
                  </div>
                </div>
                <div className="self-stretch flex flex-col justify-start items-start gap-2.5">
                  <div style={{border: '1px solid rgba(60, 59, 59, 0.2)'}} className="self-stretch h-10 px-4 py-1 bg-white rounded-full focus-within:border-opacity-20 inline-flex justify-start items-center">
                    <div className="w-full h-full flex justify-start items-start overflow-hidden">
                      <input className="w-full h-full justify-center bg-white text-[#636262] text-xs font-normal font-['Figtree'] leading-relaxed outline-none focus:outline-none focus:ring-0 placeholder-[#636262]" placeholder="Phone"/>
                    </div>
                  </div>
                  <div style={{border: '1px solid rgba(60, 59, 59, 0.2)'}} className="self-stretch h-10 px-4 py-1 bg-white rounded-full focus-within:border-opacity-20 inline-flex justify-start items-center">
                    <div className="w-full h-full flex justify-start items-start overflow-hidden">
                      <input className="w-full h-full justify-center bg-white text-[#636262] text-xs font-normal font-['Figtree'] leading-relaxed outline-none focus:outline-none focus:ring-0 placeholder-[#636262]" placeholder="Email"/>
                    </div>
                  </div>
                </div>
                <div style={{border: '1px solid rgba(60, 59, 59, 0.2)'}} className="self-stretch h-10 px-4 py-1 bg-white rounded-full focus-within:border-opacity-20 inline-flex justify-between items-center">
                  <div className="w-full h-full flex justify-start items-start overflow-hidden">
                    <select data-theme="light" className="select select-ghost w-full h-full pl-0 justify-center bg-white text-[#636262] text-xs font-normal font-['Figtree'] leading-relaxed outline-none focus:outline-none focus:ring-0">
                      <option value="" disabled selected>What best describes your situation?</option>
                      <option value="institution">I represent an institution (Bank, Wealth Manager, MFO, etc)</option>
                      <option value="current_investor">I'm a current investor</option>
                      <option value="fund_manager">I'm a Fund Manager</option>
                      <option value="partnership">I'm interested in a partnership/collaboration</option>
                      <option value="journalist">I'm a journalist/media representative</option>
                      <option value="other">Other (none of the above)</option>
                    </select>
                  </div>
                </div>
                <div style={{border: '1px solid rgba(60, 59, 59, 0.2)'}}
                     className="self-stretch h-40 px-4 py-1 bg-white rounded-xl focus-within:border-opacity-20 inline-flex justify-start items-start">
                  <div className="w-full h-full flex justify-start items-start overflow-hidden">
                    <textarea
                      value={message}
                      onChange={(e) => setMessage(e.target.value)}
                      className="justify-center w-full h-full border-none text-[#636262] bg-white text-xs font-normal font-['Figtree'] leading-relaxed focus:outline-none placeholder-[#636262] resize-none"
                      placeholder="Message"
                    ></textarea>
                  </div>
                </div>

              </div>
              <div className="self-stretch h-10 p-4 bg-[#6E66E1] rounded-[100px] inline-flex justify-center items-center transition-all duration-300 ease-in-out group cursor-pointer">
                <div className="justify-start text-white text-sm font-bold font-['Figtree']">Send</div>
                <svg className="ml-2 transition-all duration-300 ease-in-out transform  group-hover:translate-x-1" width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M0.822291 10.9291L9.9982 1.75314L2.13314 1.75314L2.06572 0.696975L11.8034 0.696975L11.8034 10.4347L10.7473 10.3673L10.7473 2.50219L1.57134 11.6781L0.822291 10.9291Z" fill="white"/>
                </svg>
              </div>
            </div>
            <div className="w-96 justify-start leading-none">
              <span className="text-[#676767] text-xs font-normal font-['Figtree'] leading-none">© 2025 Polaris. All Rights Reserved. By continuing, you agree to Polaris’</span>
              <span className="text-[#676767] text-xs font-normal font-['Figtree'] leading-none cursor-pointer"> <Link to={`/terms-of-use`} target={`_blank`} className="underline underline-offset-2">Terms of Use</Link></span>
              <span className="text-[#676767] text-xs font-normal font-['Figtree'] leading-none"> and </span>
              <span className="text-[#676767] text-xs font-normal font-['Figtree'] leading-none cursor-pointer"><Link to={`/privacy-policy`} target={`_blank`} className="underline underline-offset-2">Privacy Policy</Link>.</span>
            </div>
          </div>
        </section>
      </div>
  );
}
